module.exports = __webpack_public_path__ + "img/back2.13d10ff2.png";